namespace GeniuzPOS.AdvPromo {
    export class PsPromoAvShopColumns {
        static columnsKey = 'AdvPromo.PsPromoAvShop';
    }
}
